import { useQuery } from "@tanstack/react-query";
import EmailTemplatesHandler from "../../../components/admin/messages/EmailTemplatesHandler";
import { getTemplate } from "../../../services/emailTemplateService";

const EmailTemplates = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["templates"],
    queryFn: getTemplate,
  });

  if (isLoading) return <div>Loading templates...</div>;
  if (error) return <div>Failed to load templates.</div>;

  return <EmailTemplatesHandler template={data?.data} />;
};

export default EmailTemplates;
